<template>
<div>
    <header>
        <h1>Login</h1>
    </header>
    <custom-form :fields="[ 'username', 'password' ]"
                 :hiddenFields="{ role: this.role }"
                 submitLabel="Einloggen" 
                 url="login"
                 @submitted="loggedIn" />
</div>
</template>

<script>
import base from 'base.vue'
import customForm from 'components/custom-form.vue'

export default {
    mixins: [ base ],
    components: { customForm },
    props: [ 'role' ],
    data () {
        return { }
    },
    methods: {
        loggedIn (response) {
            response.data.user.api_token = response.data.api_token
            window.store.commit('login', response.data.user)
            window.router.push('/')
        },
        signup () {
            window.router.push('/signup')
        }
    }
}
</script>



// WEBPACK FOOTER //
// login.vue?0549107a